import React from "react";
import PropTypes from "prop-types";

const Row = ({ hide, className = "", py, children, ...rest }) => {
  if (hide) {
    return null;
  }

  const pyClass = py ? `py-${py}` : "";
  const combinedClass = `row ${className} ${pyClass}`.trim();

  return (
    <div {...rest} className={combinedClass}>
      {children}
    </div>
  );
};

Row.propTypes = {
  hide: PropTypes.bool,
  className: PropTypes.string,
  py: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  children: PropTypes.node,
};

export default Row;



// WEBPACK FOOTER //
// ./src/design-system/layout/Row/Row.jsx